import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.number().notRequired(),
  name: yup.string().required().min(3).max(100),
  description: yup.string().required().min(3).max(100),
  plan_type: yup.string().required().min(3).max(100),
  max_users: yup.number().required().moreThan(0),
  isArticleIA: yup.boolean(),
  message_limit: yup
    .number()
    .required()
    .nullable()
    .when("isArticleIA", {
      is: true,
      then: (schema) => schema.required("é obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
});
